import ActivityList from 'js/activity/List'
import { useSiteStore } from 'js/lib/stores'
import PageItem from 'js/page/Item'

const Index = () => {
    const startPage = useSiteStore(({ site }) => site.startpage)
    const startPageCms = useSiteStore(({ site }) => site.startpageCms)

    if (startPage === 'cms' && startPageCms) {
        return <PageItem guid={startPageCms} isHome />
    } else {
        return <ActivityList />
    }
}
export default Index
